<template>
  <div class="radius-8px over-h">
    <img class="title" :src="info.topImgUrl" alt="" ref="titleEl" />
    <div class="imgpath flex-js-ac flex-w">
      <div class="pos-r w-50" v-for="(item, index) of info.goodsList" :key="index" ref="goodsEls">
        <img
          class="of-c w-100"
          :src="item.imgUrl"
          alt=""
          @click="clickHandle(item, index)"
        />
        <div
          :path="item.adTarget + (item.adTarget.indexOf('?') >= 0 ? '&' : '?') + 'sorce=15'"
          :username="'gh_5d4bb8e18b8b'"
          class="slide_cl_xcx"
          v-if="isWx && (item.adType == 7 || item.adType == 8)"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { isWeixin } from '../../../assets/common/js/config'
import adExposeMixin from '../js/adExposeMixin'
export default {
  name: 'actGoodsAd',
  mixins: [adExposeMixin],
  props: {
    info: {
      type: Object,
      default: {}
    },
    /** 埋点 flowArea 前缀，如 bannerZone */
    flow_area_prefix: {
      type: String,
      default: 'ITEMSHF'
    },
  },
  data() {
    return {
      isWx: isWeixin() ? 1 : 0
    }
  },
  mounted() {
    this.scheduleAdExposeBindHandle(this.bindGoodsAdExposeHandle)
  },
  watch: {
    info: {
      handler: function () {
        this.scheduleAdExposeBindHandle(this.bindGoodsAdExposeHandle)
      },
      deep: true
    }
  },
  methods: {
    bindGoodsAdExposeHandle: function () {
      var list = (this.info && this.info.goodsList) || []
      if (this.$refs.titleEl && this.info) {
        this.bindAdExposeHandle(this.$refs.titleEl, this.flow_area_prefix, {
          ad_title: this.info.ad_title || '',
          ad_type: '',
          ad_target: ''
        })
      }
      var els = this.$refs.goodsEls
      if (!els) return
      if (!Array.isArray(els)) els = [els]
      for (var i = 0; i < els.length; i++) {
        if (els[i] && list[i]) {
          this.bindAdExposeHandle(els[i], this.flow_area_prefix + '-' + (i + 1), {
            ad_type: list[i].adType,
            ad_target: list[i].adTarget,
            ad_title: list[i].adtitle
          })
        }
      }
    },
    clickHandle(item, index) {
      let info = {
        ad_type: item.adType,
        ad_target: item.adTarget,
        ad_title: item.adtitle,
        ...item
      }
      this.$emit('banner-click', info, index, this.flow_area_prefix)
    },
  }
}
</script>

<style scoped lang="scss">
.title {
  width: 100%;
}
.imgpath img {
  width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/components/actGoodsAd.vue